import { render } from "./HomeGameList.vue?vue&type=template&id=6579012e&scoped=true"
import script from "./HomeGameList.vue?vue&type=script&lang=js"
export * from "./HomeGameList.vue?vue&type=script&lang=js"

import "./HomeGameList.vue?vue&type=style&index=0&id=6579012e&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6579012e"]])

export default __exports__